/**
 * @generated SignedSource<<ef531a8611b60f81216f1c55259f39d1>>
 * @relayHash 8499613815500745d0c01a4eb93974be
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8bc5f71da323efb2a6644b985dae8ff2fcdde60f5f6e486afedfd1a09c940cad

import type { ConcreteRequest, Query } from 'relay-runtime';
export type fetchPresenceConfluenceUsersQuery$variables = {
  accountIds?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type fetchPresenceConfluenceUsersQuery$data = {
  readonly confluenceUsers: {
    readonly nodes: ReadonlyArray<{
      readonly accountId?: string | null | undefined;
      readonly displayName: string | null | undefined;
      readonly profilePicture: {
        readonly isDefault: boolean | null | undefined;
        readonly path: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type fetchPresenceConfluenceUsersQuery = {
  response: fetchPresenceConfluenceUsersQuery$data;
  variables: fetchPresenceConfluenceUsersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountIds"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "accountIds",
    "variableName": "accountIds"
  }
],
v2 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isDefault"
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "RELATIVE"
        }
      ],
      "kind": "ScalarField",
      "name": "path",
      "storageKey": "path(type:\"RELATIVE\")"
    }
  ]
},
v3 = [
  {
    "kind": "ScalarField",
    "name": "accountId"
  }
],
v4 = {
  "kind": "InlineFragment",
  "selections": (v3/*: any*/),
  "type": "KnownUser"
},
v5 = {
  "kind": "InlineFragment",
  "selections": (v3/*: any*/),
  "type": "UnknownUser"
},
v6 = {
  "kind": "ScalarField",
  "name": "displayName"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "fetchPresenceConfluenceUsersQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "PaginatedPersonList",
        "kind": "LinkedField",
        "name": "confluenceUsers",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "fetchPresenceConfluenceUsersQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "PaginatedPersonList",
        "kind": "LinkedField",
        "name": "confluenceUsers",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              (v2/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "8499613815500745d0c01a4eb93974be",
    "id": "8bc5f71da323efb2a6644b985dae8ff2fcdde60f5f6e486afedfd1a09c940cad",
    "metadata": {},
    "name": "fetchPresenceConfluenceUsersQuery",
    "operationKind": "query",
    "text": "query fetchPresenceConfluenceUsersQuery($accountIds:[String]){confluenceUsers(accountIds:$accountIds){nodes{__typename,profilePicture{isDefault,path(type:RELATIVE)},...on KnownUser{accountId},...on UnknownUser{accountId},displayName}}}"
  }
};
})();

(node as any).hash = "e12a89d36736ce93af285cf23f78d2f2";

export default node;
